import { render, staticRenderFns } from "./software-list.vue?vue&type=template&id=5936564a&scoped=true&"
import script from "./software-list.vue?vue&type=script&lang=js&"
export * from "./software-list.vue?vue&type=script&lang=js&"
import style0 from "./software-list.vue?vue&type=style&index=0&id=5936564a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5936564a",
  null
  
)

export default component.exports